import React, { useCallback } from "react";
import Button from "@dtci/spellbook/Button";

/**
 * Action cell — clicking it opens the appropriate drawer for this row.
 * Owns its own click handler (rather than relying on the grid's onRowClicked
 * with a column-id check), so the click target is reliable on pinned columns
 * and the row-click semantics elsewhere stay independent.
 *
 * Behavior depends on the row type:
 *   - Discount rows (no parentDiscountId) → open parent discount drawer
 *   - ClientDiscount rows (has parentDiscountId) → open client discount drawer
 *
 * The drawer-open functions come off the grid's `context` prop, set by the
 * parent grid component.
 */
export const OpenDrawerCellRenderer = (params) => {
  const handleClick = useCallback(
    (e) => {
      const data = params?.data;
      if (!data) {
        console.warn("[OpenDrawerCellRenderer] No data");
        return;
      }

      // If this row has a parentDiscountId, it's a ClientDiscount row — open
      // the client discount drawer with the full row data
      if (data.parentDiscountId) {
        const openClientDiscountDrawer =
          params?.context?.openClientDiscountDrawer;
        if (openClientDiscountDrawer) {
          openClientDiscountDrawer(data);
        } else {
          console.warn(
            "[OpenDrawerCellRenderer] openClientDiscountDrawer not in context",
            params?.context,
          );
        }
      } else {
        // Otherwise it's a Discount row — open the parent discount drawer
        const openDrawer = params?.context?.openDrawer;
        if (openDrawer && data.id) {
          openDrawer(data.id);
        } else {
          console.warn("[OpenDrawerCellRenderer] openDrawer not in context");
        }
      }
    },
    [params],
  );

  return (
    <Button
      styleType="flat"
      colorType="secondary"
      iconPlacement="before"
      iconType="fa-arrow-up-right-from-square"
      onClick={handleClick}
      title="Open details"
      aria-label="Open details"
      style={{ width: 30, height: 30 }}
    />
  );
};
